var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.569,
    height: 18.991,
    viewBox: "0 0 18.569 18.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.411)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.4,258.673a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431v-1.5Z",
    transform: "translate(-112.693 -248.196)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.036,258.673a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431Z",
    transform: "translate(-205.568 -248.196)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.664,258.673a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431Z",
    transform: "translate(-298.437 -248.196)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,355.306a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431v-1.5Z",
    transform: "translate(-112.693 -341.069)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.036,355.306a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431Z",
    transform: "translate(-205.568 -341.069)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.664,355.306a.431.431,0,0,0-.431-.431h-1.5a.431.431,0,0,0-.431.431v1.5a.431.431,0,0,0,.431.431h1.5a.431.431,0,0,0,.431-.431v-1.5Z",
    transform: "translate(-298.437 -341.069)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.328,54.15v2.3a1.876,1.876,0,0,1-1.88,1.875H19.261a1.886,1.886,0,0,1-1.892-1.875V54.142H12.022v2.305a1.886,1.886,0,0,1-1.892,1.875H8.944a1.876,1.876,0,0,1-1.88-1.875v-2.3a1.71,1.71,0,0,0-1.653,1.7V69.314a1.711,1.711,0,0,0,1.7,1.712H22.278a1.713,1.713,0,0,0,1.7-1.712V55.851A1.71,1.71,0,0,0,22.328,54.15Zm-.551,14.325a.736.736,0,0,1-.736.736H8.318a.736.736,0,0,1-.736-.736V61.522a.736.736,0,0,1,.736-.736H21.041a.736.736,0,0,1,.736.736v6.954Z",
    transform: "translate(-5.411 -52.036)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.195,5.055h1.173a.645.645,0,0,0,.645-.645V.645A.645.645,0,0,0,81.368,0H80.195a.645.645,0,0,0-.645.645V4.411A.645.645,0,0,0,80.195,5.055Z",
    transform: "translate(-76.666)",
    fill: "#112c5a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.1,5.055h1.173a.645.645,0,0,0,.645-.645V.645A.645.645,0,0,0,346.276,0H345.1a.645.645,0,0,0-.645.645V4.411A.645.645,0,0,0,345.1,5.055Z",
    transform: "translate(-331.268)",
    fill: "#112c5a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.3c684c26604c4c64bcb7da46bd4496dd.svg";
export { ForwardRef as ReactComponent };